import {
  FETCH_ERROR,
  FETCH_START,
  FETCH_SUCCESS,
  SHOW_MESSAGE,
  SOMETHING_WENT_WRONG,
} from '../../Constant/ActionTypes';
import {HttpCode} from '../../Constant/HttpCode';
import Urls from '../../Constant/Urls';
import {httpClient} from './../../Api/client';

export const getPbssFilesList = (params = {}) => {
  return async (dispatch) => {
    dispatch({type: FETCH_START});
    try {
      const {
        page = 1,
        pageCount = 10,
        type = 'international',
        format,
      } = params;
      const requestParams = {page, pageCount, type};
      if (format && format !== 'all') {
        requestParams.format = format;
      }
      const {data} = await httpClient.get(Urls.PBSS_FILES_GET, {
        params: requestParams,
      });
      dispatch({type: FETCH_SUCCESS});
      return data?.data;
    } catch (error) {
      const errorMessage =
        error?.response?.data?.errorMessage ||
        error?.response?.status === HttpCode.BadRequest
          ? error?.response?.data?.errorMessage
          : SOMETHING_WENT_WRONG;
      dispatch({type: FETCH_ERROR, payload: errorMessage});
      return null;
    }
  };
};

export const uploadPbssFile = (formData) => {
  return async (dispatch) => {
    dispatch({type: FETCH_START});
    try {
      const {data} = await httpClient.post(Urls.PBSS_FILES_ADD, formData, {
        headers: {'Content-Type': 'multipart/form-data'},
      });
      dispatch({type: FETCH_SUCCESS});
      dispatch({type: SHOW_MESSAGE, payload: data?.message || 'File uploaded successfully.'});
      return data?.data;
    } catch (error) {
      const errorMessage =
        error?.response?.data?.errorMessage ||
        (error?.response?.status === HttpCode.BadRequest
          ? error?.response?.data?.errorMessage
          : SOMETHING_WENT_WRONG);
      dispatch({type: FETCH_ERROR, payload: errorMessage});
      throw error;
    }
  };
};

export const deletePbssFile = (id) => {
  return async (dispatch) => {
    dispatch({type: FETCH_START});
    try {
      await httpClient.delete(Urls.PBSS_FILES_DELETE.replace('#{fileId}', id));
      dispatch({type: FETCH_SUCCESS});
      dispatch({type: SHOW_MESSAGE, payload: 'File deleted successfully.'});
      return true;
    } catch (error) {
      const errorMessage =
        error?.response?.data?.errorMessage || SOMETHING_WENT_WRONG;
      dispatch({type: FETCH_ERROR, payload: errorMessage});
      return false;
    }
  };
};
